module.exports = __webpack_public_path__ + "img/jigouyanglao.d87aa5d3.png";